import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { NotificationsAlertTriangleIcon } from '../../../../ui/Icons';
import { BodyText } from '../../../../ui';

type LoginErrorBannerProps = {
  errorText: string;
};

export const LoginErrorBanner: React.FCWithChildren<LoginErrorBannerProps> = ({
  errorText,
}) => (
  <Box>
    <Inline
      padding={16}
      borderRadius={4}
      color={BrandColor.LightRed}
      alignItems="center"
    >
      <Box paddingRight={12}>
        <NotificationsAlertTriangleIcon color={BrandColor.Red} width={24} height={24} />
      </Box>
      <BodyText appearance="small" testID="login_signup_error_banner_text">
        {errorText}
      </BodyText>
    </Inline>
  </Box>
);
